/**
 * Vendor
 */
import React from 'react';
import Swal from 'sweetalert2';

/**
 * CARIBE7 MODULES
 */
import BaseAlertService from '@shared/services/base/alerts/BaseAlertService';

/**
 * Loading Alert Service
 *
 * @class      LoadingAlertService (name)
 */
function LoadingAlertService(component) {
  this.component   = component;
}

LoadingAlertService.prototype = Object.assign(LoadingAlertService.prototype, BaseAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
LoadingAlertService.prototype.registerLoadingAlertEvents = function(self, service) {
  var event_callback_map                               = {};
  event_callback_map[this.event_group.LOADING_DISPLAY] = 'onLoadingDisplay';
  event_callback_map[this.event_group.LOADING_STOP]    = 'onLoadingStop';
  event_callback_map[this.event_group.LOADING_SUCCESS] = 'onLoadingSuccess';
  event_callback_map[this.event_group.LOADING_FAIL]    = 'onLoadingFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
LoadingAlertService.prototype.removeLoadingAlertEvents = function() {
  this.removeEvents([
    this.event_group.LOADING_DISPLAY,
    this.event_group.LOADING_STOP,
    this.event_group.LOADING_SUCCESS,
    this.event_group.LOADING_FAIL
  ]);
  return this;
}


/**
 * Called when success alert display
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
LoadingAlertService.prototype.onLoadingDisplay = function({
  title='Loading',
  message='',
  options={},
  onConfirm,
  onResolve,
  onError
}) {
  options['didOpen'] = () => {
    Swal.showLoading()
  }
  this.createSwal({
    props: {
      title: <span>{title}</span>,
      html:  <span>{message}</span>,
      icon:  '',
    },
    options: options,
    onConfirm: onConfirm,
    onResolve: onResolve,
    onError:   onError,
  });
};


LoadingAlertService.prototype.onLoadingStop = function() {
  Swal.close();
}

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
LoadingAlertService.prototype.onLoadingSuccess = function(response) {
  console.log("LoadingAlertService::onLoadingSuccess", response);
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
LoadingAlertService.prototype.onLoadingFail = function(error) {
  console.log("LoadingAlertService::onLoadingFail", error);
}

export default LoadingAlertService;